import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  MapRender: {
    height: '100vh',
    overflow: 'hidden',
    width: '100%',
    '&__box': {
      width: '100%',
      height: '100%',
      position: 'relative',
      '&__controls': {
        '&__scale': {
          background: 'rgba(11, 17, 32, 0.8)',
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          border: '1px solid rgba(14, 165, 233, 0.15)',
          borderRadius: '6px',
          bottom: 30,
          color: '#F8FAFC',
          left: 15,
          opacity: 0.9,
          padding: '2px',
          position: 'absolute',
          zIndex: 600,
          '&__inner': {
            border: `1px solid ${theme.palette.white}`,
            borderTop: 'none',
            fontSize: '10px',
            margin: '1px',
            textAlign: 'center',
            transition: 'all 0.25s',
            willChange: 'contents, width',
          },
        },
      },
      '&__icon': {
        '&__inner': {
          top: '50%',
          cursor: 'pointer',
          position: 'absolute',
          zIndex: 1002,
          left: '50%',
          transform: 'translate(-50%, -50%)',
          height: '25px !important',
          width: '25px !important',
        },
        '&__outer': {
          position: 'absolute',
          bottom: 62,
          left: 10,
          zIndex: '1001',
        },
        '&__tooltip': {
          fontSize: '16px',
        },
        '&--z-index': {
          zIndex: '1001',
        },
      },
    },
  },
  '@global': {
    '.ol-zoom': {
      background: 'rgba(11, 17, 32, 0.8)',
      backdropFilter: 'blur(8px)',
      WebkitBackdropFilter: 'blur(8px)',
      border: '1px solid rgba(14, 165, 233, 0.15)',
      borderRadius: '8px !important',
      padding: '4px',
      marginLeft: '15px',
      marginTop: '10px',
    },
    '.ol-zoom button': {
      display: 'block',
      margin: '2px auto',
      padding: 0,
      fontWeight: 'bold',
      textDecoration: 'none',
      fontSize: 'inherit',
      textAlign: 'center',
      height: '1.375em',
      width: '1.375em',
      lineHeight: '.4em',
      backgroundColor: 'rgba(0,60,136,0.5)',
      border: 'none',
      borderRadius: '2px',
    },
    '.ol-zoom-in': {
      background: 'rgba(11, 17, 32, 0.8) !important',
      color: '#F8FAFC !important',
      border: '1px solid rgba(14, 165, 233, 0.2) !important',
      borderRadius: '6px !important',
      backdropFilter: 'blur(8px)',
      marginTop: 2,
      transition: 'background-color 0.2s ease, border-color 0.2s ease',
      '&:hover': {
        background: 'rgba(6, 182, 212, 0.2) !important',
        borderColor: 'rgba(6, 182, 212, 0.5) !important',
        color: '#F8FAFC !important',
      },
    },
    '.ol-zoom-out': {
      background: 'rgba(11, 17, 32, 0.8) !important',
      color: '#F8FAFC !important',
      border: '1px solid rgba(14, 165, 233, 0.2) !important',
      borderRadius: '6px !important',
      backdropFilter: 'blur(8px)',
      transition: 'background-color 0.2s ease, border-color 0.2s ease',
      marginTop: 2,
      '&:hover': {
        background: 'rgba(6, 182, 212, 0.2) !important',
        borderColor: 'rgba(6, 182, 212, 0.5) !important',
        color: '#F8FAFC !important',
      },
    },
    '.ol-attribution li': {
      listStyle: 'none',
      position: 'absolute',
      bottom: '0.5em',
      left: '0.5em',
      fontSize: '0.8em',
    },
    '.ol-attribution button': {
      display: 'none',
    },
    '.ol-rotate': {
      display: 'none',
    },
  },
}));

export { useStyles };
